<template>
  <Popup
    header-background-color="#1A73E8"
    header-text-color="text-static-light-hi"
  >
    <template #logo>
      <RevIllustration
        :alt="i18n(translations.logo)"
        :height="24"
        src="/img/telco-partnership/google-fi.svg"
        :width="24"
      />
    </template>

    <template #title>
      {{ i18n(translations.popupTitle) }}
    </template>

    <template #body>
      <p class="body-1">
        <FormattedMessage :definition="translations.popupBody">
          <template #link>
            <RevLink target="_blank" :to="GOOGLE_FI_TERMS_URL">
              {{ i18n(translations.termsLink) }}
            </RevLink>
          </template>
        </FormattedMessage>
      </p>

      <div class="bg-static-info-mid rounded-md space-y-12 px-16 py-20">
        <h3 class="body-1-bold">
          {{ i18n(translations.stepsTitle) }}
        </h3>

        <RevTextList class="[counter-set:list-item]" variant="ordered">
          <RevTextListItem>
            {{ i18n(translations.step1) }}
          </RevTextListItem>
          <RevTextListItem>
            {{ i18n(translations.step2) }}
          </RevTextListItem>
          <RevTextListItem>
            {{ i18n(translations.step3) }}
          </RevTextListItem>
        </RevTextList>
      </div>
    </template>
  </Popup>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'

import Popup from '../Popup/Popup.vue'

import translations from './GoogleFiPopup.translations'

const GOOGLE_FI_TERMS_URL =
  'https://fi.google.com/about/backmarket#fi-backmarket-terms'

const i18n = useI18n()
</script>
